import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import classNames from 'classnames'

import { getCDNUrl } from '@shared'
import { InventoryCard } from '@store'

import styles from './InventoryThing.module.scss'
import { useMemo } from 'react'

interface InventoryThingProps {
  card: InventoryCard
  className?: string
}

export const InventoryThing = ({ card, className }: InventoryThingProps) => {

  const content = useMemo(() => {
    if (card.appFiles) {
      const extension = card.appFiles.split('.').pop()
      if (extension === 'lottie') {
        return <DotLottieReact src={getCDNUrl(card.appFiles)} width={110} height={110} autoplay loop />
      }
      if (extension === 'mp4') {
        return <video src={getCDNUrl(card.appFiles)} autoPlay loop muted playsInline className={classNames(styles.image, {
          [styles.mask]: true,
        })} />
      }
    }
    return <img src={card?.iconUrl} className={classNames(styles.image, {
      [styles.mask]: card.displayType === 'avatar',
    })} />
  }, [card])
  return (
    <div className={classNames(styles.thingInner, className)}>
      {content}
    </div>
  )
}
